import React from "react";
import styles from "./styles.module.css";
import { MdExpandMore } from "react-icons/md";
import ClickAwayListener from "react-click-away-listener";
import Toggle from "./toggle";
import Pages from "./pages";
import Components from "./components"
export default function PageSelect() {
  const [open, setOpen] = React.useState(false);
  const [toggle, setToggle] = React.useState("pages");
  const [title, setTitle] = React.useState("index");
  return (
    <div className={styles.pageSelect}>
      <div onClick={() => setOpen(true)} className={styles.pagesButton}>
        {title}
        <MdExpandMore />
      </div>

      <ClickAwayListener
        mouseEvent={"mousedown"}
        onClickAway={() => setOpen(false)}
      >
        <div
          className={
            open
              ? `${styles.pagesDropdown} ${styles.open}`
              : styles.pagesDropdown
          }
        >
          <Toggle value={toggle} onChange={setToggle} />
          {toggle === "pages" ? (
            <Pages setTitle={setTitle} setOpen={setOpen} />
          ) : (
            <Components setTitle={setTitle} setOpen={setOpen} />
          )}
        </div>
      </ClickAwayListener>
    </div>
  );
}
